import './style.scss';
import { Portfolio } from './PortfolioDetails/Portfolio';
import { PortfolioModel } from './PortfolioDetails/PortfolioModel';
import { Slider } from '../../../js/components/Slider/Slider';

export default !function () {
  const wrapper = document.querySelector('.portfolio-v1__wrapper');

  if (!wrapper) {
    return;
  }

  const list = wrapper.querySelector('.portfolio-v1__list');
  const items = list.querySelectorAll('.portfolio-v1__item');
  const controls = wrapper.querySelector('.portfolio-v1__controls');

  const options = {
    wrapper,
    settings: {
      loop: false,
      spaceBetween: 8,
      slideClass: 'portfolio-v1__item',
      wrapperClass: 'portfolio-v1__list',
      freeMode: true,

      breakpoints: {
        768: {
          spaceBetween: 24,
          slidesPerView: 2
        },
        1024: {
          spaceBetween: 32,
          slidesPerView: 3,
          slidesPerGroup: 3,
          freeMode: false,

          pagination: {
            el: '.portfolio-v1__current',
            type: 'fraction'
          },
          navigation: {
            nextEl: '.button-arrow--next',
            prevEl: '.button-arrow--prev',
            disabledClass: 'button-arrow--disabled'
          }
        },
      }
    },
    modules: ['pagination', 'navigation', 'freeMode'],
    initCondition: {
      sm: items.length > 3,
      md: items.length > 5,
      lg: items.length > 6,
      xl: items.length > 6
    },
    controls,
    createCallback: () => {
      list.classList.remove('portfolio-v1__list--static');
      list.classList.add('portfolio-v1__list--slider');
    },
    destroyCallback: () => {
      list.classList.add('portfolio-v1__list--static');
      list.classList.remove('portfolio-v1__list--slider');
    }
  };

  new Slider(options).init();

  /* Preview Popup */
  const portfolioModel = new PortfolioModel();
  const blockName = document.querySelector('.portfolio-v1').dataset.blockName ?? 'Блок без названия'

  list.addEventListener('click', (evt) => {
    evt.preventDefault();

    const card = evt.target.closest('.portfolio-v1__item');

    if (card) {
      new Portfolio(card, list, portfolioModel, blockName).init();
      window.$analytics && window.$analytics.push('portfolio-card-click');
    }
  });
}();
